import { OTDSUser, UserService } from 'src/app/service/user.service';
import { Environment } from './../../model/SolutionInfo';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged, tap, finalize } from 'rxjs/operators';
import { Solution } from 'src/app/model/SolutionInfo';
import { SolutionService } from 'src/app/service/solution.service';
import { UserInfo, UserRole } from './../../model/User';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { passwordValidator } from '../../validator/user-form-validator';
import { of } from 'rxjs';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { OrderByPipe } from 'src/app/pipe/order-by.pipe';
import { emptyValidator } from 'src/app/validator/empty-form-validator';
import { PageCount } from '../controls/pagination/pagination.component';
import { Tab, TabColor } from '../controls/tabs/tabs.component';

interface UserForm {
  userNameCtrl: FormControl<string>;
  OTDSUserNameCtrl: FormControl<string>;
  userRoleCtrl: FormControl<string>;
  givenNameCtrl: FormControl<string>;
  surNameCtrl: FormControl<string>;
  dataCtrl: FormControl<any>;
  newPasswordCtrl?: FormControl<string>;
  confirmNewPasswordCtrl?: FormControl<string>;
}

export enum UserFormTab {
  GENERAL,
  PERMISSIONS
}

export enum UserFormType {
  LOCAL = "local",
  OTDS = "otds"
}

export enum UserFormMode {
  ADD,
  EDIT
}

//local validator
export function checkfIfPasswordTheSame(group: FormGroup) {
  if(group.get('newPasswordCtrl').touched || group.get('confirmNewPasswordCtrl').touched){
    return group.get('newPasswordCtrl').value === group.get('confirmNewPasswordCtrl').value ? null : {passwordNotSame: true};
  }else{
    return null;
  }
}

@Component({
    selector: 'app-user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.css'],
    standalone: false
})
export class UserFormComponent implements OnInit {

  @Input() currentTab: UserFormTab = UserFormTab.GENERAL;
  @Input() currentUserAuthInfo : UserInfo;
  @Input() isEditRoleAllowed = false;
  @Input() permissionTabHeight:string;
  @Input() formHeight:string ='300px';
  @Input() type:UserFormType = UserFormType.LOCAL;
  @Output() formEvent = new EventEmitter<FormGroup>();
  @Output() errorEvent = new EventEmitter<boolean>();

  tabs: Tab[] = [];
  generalTab = new Tab('otsc-user-form-general-tab', $localize`General`, undefined, true);
  permissionsTab = new Tab('otsc-user-form-permission-tab', $localize`Permissions`, undefined, false);
  TabColor = TabColor;

  UserFormType = UserFormType;
  UserRole = UserRole;
  UserFormTab = UserFormTab;
  isRequireEmailValidation:boolean = true;
  userInfo:UserInfo;
  roleOptions:any;
  OTDSUsers:OTDSUser[] = [];
  isSearchingOTDSUser: boolean = true;
  //solution manager permissions
  solManagerPermTableTitle = "Assigned Solutions";
  solManagerPermTablePagination = false;
  solManagerPermShowcheckboxes = true;
  solManagerPermTableCols:DataTableColumn[] = [new DataTableColumn("name", $localize`:@@userform.perm.solName:Solution name`, ColumnType.STRING, true, "49", ColumnSort.ASC),
                                                new DataTableColumn("description", $localize`:@@userform.perm.solDesc:Solution description`, ColumnType.STRING, false, "51")];
  solManagerPermTableRows:DataTableRow[] = [];
  solManagerPermTableTotal = 0;
  solManagerSelectedSolutions:Solution[] = [];
  //environment manager permissions
  envManagerPermTableTitle = "Assigned Environments";
  envManagerPermTablePagination = false;
  envManagerPermShowcheckboxes = true;
  envManagerPermTableCols:DataTableColumn[] = [new DataTableColumn("solName", $localize`:@@userform.perm.solName:Solution name`, ColumnType.STRING, true, "43", ColumnSort.ASC),
                                                new DataTableColumn("name", $localize`:@@userform.perm.envName:Environment name`, ColumnType.STRING, false, "57")];
  envManagerPermTableRows:DataTableRow[] = [];
  envManagerPermTableTotal = 0;
  envManagerSelectedEnvironments:Environment[] = [];
  //permission pagination
  startingPage:number = 1;
  noOfPages:number = 1;
  startingIndex:number = 0;
  starting:number = 1;
  ending:number = 10;
  currentPage:number;
  noOfItemsPerPage: number = PageCount.TWENTYFIVE;
  noOfItems:number;
  lastIndexValue:number;
  UserFormMode = UserFormMode;
  mode:UserFormMode;
  role:string;
  isLoadingPerm:boolean = false;
  userForm: FormGroup<UserForm>;
  enterSurnamePlaceholder:string = $localize`Enter surname`;
  enterGivenNamePlaceholder:string = $localize`Enter given name`;
  
  constructor(private solutionService: SolutionService,
              private orderBy: OrderByPipe,
              private renderer: Renderer2,
              private userService: UserService,
              private eleRef: ElementRef,) { 
    this.tabs = [this.generalTab, this.permissionsTab];
  }

  //member functions
  get userNameCtrl() { return this.userForm.get('userNameCtrl'); }
  get OTDSUserNameCtrl() { return this.userForm.get('OTDSUserNameCtrl');}
  get userRoleCtrl() { return this.userForm.get('userRoleCtrl'); }
  get givenNameCtrl() { return this.userForm.get('givenNameCtrl'); }
  get surNameCtrl () { return this.userForm.get('surNameCtrl'); }
  get newPasswordCtrl() { return this.userForm.get('newPasswordCtrl'); }
  get confirmNewPasswordCtrl() { return this.userForm.get('confirmNewPasswordCtrl'); }
  get dataCtrl () { return this.userForm.get('dataCtrl');}

  ngOnInit(): void {
    this.userForm = new FormGroup<UserForm>({
      userNameCtrl: new FormControl('', [Validators.required, Validators.pattern("[a-zA-Z0-9\-\_\.\@ ]*")]),
      OTDSUserNameCtrl: new FormControl('', []),
      userRoleCtrl: new FormControl('', [Validators.required]),
      givenNameCtrl: new FormControl('', []),
      surNameCtrl: new FormControl('', []),
      dataCtrl: new FormControl('', [Validators.required]),
      newPasswordCtrl: new FormControl('', [passwordValidator()]),
      confirmNewPasswordCtrl: new FormControl('', []),
    });
    if(this.type == UserFormType.LOCAL){
      this.givenNameCtrl.setValidators([Validators.required, emptyValidator()]);
      this.surNameCtrl.setValidators([Validators.required, emptyValidator()]);
      this.userForm.setValidators(checkfIfPasswordTheSame);
      this.givenNameCtrl.updateValueAndValidity();
      this.surNameCtrl.updateValueAndValidity();
    }else{
      this.userForm.removeControl('newPasswordCtrl');
      this.userForm.removeControl('confirmNewPasswordCtrl');
      this.givenNameCtrl.clearValidators();
      this.surNameCtrl.clearValidators();
    }
    this.userForm.valueChanges.subscribe(val => {
      this.formEvent.emit(this.userForm);
      this.role = this.mode == UserFormMode.EDIT ? this.userInfo.role : this.userRoleCtrl.value;
    });

    this.OTDSUserNameCtrl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()).subscribe(val => {
      this.searchOTDSUsers(val);
    })
    this.userInfo = this.currentUserAuthInfo;
    if(this.type == UserFormType.OTDS || (this.userInfo && this.userInfo.role == UserRole.SUPERUSER.toString())){
      this.isRequireEmailValidation = false;
    }else{
      this.isRequireEmailValidation = true;
    }
    this.mode = this.userInfo ? UserFormMode.EDIT : UserFormMode.ADD;
    this.role = this.mode == UserFormMode.EDIT ? this.userInfo.role : this.userRoleCtrl.value;

    if(this.mode == UserFormMode.EDIT){
      this.roleOptions = [{name:$localize`:@@userform.role.superuser:Super User`, value:"Superuser", disabled:true},
                        {name:$localize`:@@userform.role.admin:Administrator`, value:"Administrator"},
                        {name:$localize`:@@userform.role.solMgr:Solution Manager`,value:"SolutionManager"},
                        {name:$localize`:@@userform.role.envMgr:Environment Manager`,value:"EnvironmentManager"}];
      this.userNameCtrl.reset(this.userInfo.userName);
      if (this.userInfo.role === UserRole.SUPERUSER.toString()){
        this.userNameCtrl.disable();
      } else {
        this.userNameCtrl.enable();
      }
      this.userRoleCtrl.reset(this.userInfo.role);    
      if (this.userInfo.role === UserRole.SUPERUSER.toString() || !this.isEditRoleAllowed) {
        this.userRoleCtrl.disable();
      } else {
        this.userRoleCtrl.enable();
      }
      this.givenNameCtrl.setValue(this.userInfo.firstName);
      this.surNameCtrl.setValue(this.userInfo.lastName);
      if(this.userRoleCtrl.value === UserRole.SOLUTION_MANAGER.toString() && this.userInfo.solList){
        this.solManagerSelectedSolutions = this.userInfo.solList;
      }else if(this.userRoleCtrl.value === UserRole.ENVIRONMENT_MANAGER.toString() && this.userInfo.envList){
        this.envManagerSelectedEnvironments = this.userInfo.envList;
      }
      this.updateDataCtrlForm();
    }else{
      this.roleOptions = [{name:$localize`:@@userform.role.admin:Administrator`, value:"Administrator"},
                          {name:$localize`:@@userform.role.solMgr:Solution Manager`,value:"SolutionManager"},
                          {name:$localize`:@@userform.role.envMgr:Environment Manager`,value:"EnvironmentManager"}];
      this.currentUserAuthInfo = new UserInfo();
      if(this.type == UserFormType.LOCAL){
        this.newPasswordCtrl.setValidators([Validators.required, passwordValidator()]);
        this.confirmNewPasswordCtrl.setValidators(Validators.required);
      }
    }

    if(this.isRequireEmailValidation){
      setTimeout(() => this.renderer.selectRootElement('#userName').focus(), 0);
    }else{
      setTimeout(() => {
        if(this.type == UserFormType.LOCAL){
          //disable given name and surname field for SuperUser
          this.givenNameCtrl.disable();
          this.surNameCtrl.disable();
          this.renderer.selectRootElement('#newPassword').focus();
        }else if(this.type == UserFormType.OTDS){
          if(this.mode == UserFormMode.ADD){
            this.renderer.selectRootElement('#otdsUsernameSearch').focus();
          }else if(this.mode == UserFormMode.EDIT){
            this.renderer.selectRootElement('#givenName').focus();
          }
        }
        
      }, 0);
    }
    this.loadPermissionData();
    this.formEvent.emit(this.userForm);
  }

  onSelectedTabChange(selectedIndex: number) {
    var tab = this.tabs[selectedIndex];
    if (tab.id === this.permissionsTab.id) {
      setTimeout(() => this.loadPermissionData(), 0);
    }
    this.currentTab = selectedIndex;
  }

  loadPermissionData(): void {
    if(this.userRoleCtrl.value === UserRole.SOLUTION_MANAGER.toString() && this.solManagerPermTableRows.length == 0){
      this.isLoadingPerm = true;
      var tmpRows: DataTableRow[] = [];
      this.solutionService.getSolutionNames().pipe(tap(resp => {
        this.solManagerPermTableTotal = resp.body.length;
        const solutions:Solution[]= this.orderBy.transform(resp.body, 'asc', 'name') ;
        if(this.mode == UserFormMode.EDIT){
          this.solManagerSelectedSolutions = this.currentUserAuthInfo.role === UserRole.SOLUTION_MANAGER.toString() ?
                                              this.currentUserAuthInfo.solList ? this.currentUserAuthInfo.solList : solutions : [];
        }else{
          this.solManagerSelectedSolutions = [];
        }
        
        solutions.forEach(sol => {
          const row = new DataTableRow(sol, null);
          const index = this.solManagerSelectedSolutions.findIndex(selectedSol => selectedSol.name === sol.name);
          row.selected = index >= 0;
          tmpRows.push(row);
        });
        this.solManagerPermTableRows = tmpRows;
        this.updateDataCtrlForm();
        this.isLoadingPerm = false;
      }),
        catchError(resp => {
          this.errorEvent.emit(true);
          return of(resp);
        })
      ).subscribe();
    }else if(this.userRoleCtrl.value === UserRole.ENVIRONMENT_MANAGER.toString() && this.envManagerPermTableRows.length == 0){
      this.isLoadingPerm = true;
      var tmpRows: DataTableRow[] = [];
      this.solutionService.getEnvironmentNames().pipe(tap(resp => {
        this.envManagerPermTableTotal = resp.body.length;
        let environments:Environment[]= this.orderBy.transform(resp.body, 'asc', 'solName');
        if(this.mode == UserFormMode.EDIT){
          this.envManagerSelectedEnvironments = this.currentUserAuthInfo.role === UserRole.ENVIRONMENT_MANAGER.toString() ?
                                              this.currentUserAuthInfo.envList ? this.currentUserAuthInfo.envList : environments : [];
        }else{
          this.envManagerSelectedEnvironments = [];
        }

        environments.forEach(env => {
          const row = new DataTableRow(env, null);
          const index = this.envManagerSelectedEnvironments.findIndex(selectedEnv => (selectedEnv.name === env.name && selectedEnv.solName === env.solName));
          row.selected = index >= 0;
          tmpRows.push(row);
        });
        this.envManagerPermTableRows = tmpRows;
        this.updateDataCtrlForm();
        this.isLoadingPerm = false;
      }),
        catchError(resp => {
          this.errorEvent.emit(true);
          return of(resp);
        })
      ).subscribe();
    }else{
      this.updateDataCtrlForm();
    }
  }

  environmentRowClicked(selectedEnvRow:DataTableRow): void {
    this.updateSelectedEnvironments(selectedEnvRow);
    this.updateDataCtrlForm();
  }

  environmentSelectAllRowClicked(selectedEnvRow:DataTableRow[]): void {
    selectedEnvRow.forEach(dtRow => {
      this.updateSelectedEnvironments(dtRow);
    });
    this.updateDataCtrlForm();
  }

  solutionRowClicked(selectedSolutionRow:DataTableRow): void {
    this.updateSelectedSolutions(selectedSolutionRow);
    this.updateDataCtrlForm();
  }

  solutionSelectAllRowClicked(selectSolutionRows:DataTableRow[]): void {
    selectSolutionRows.forEach(dtRow => {
      this.updateSelectedSolutions(dtRow);
    });
    this.updateDataCtrlForm();
  }

  updateSelectedEnvironments(selectedSolutionRow:DataTableRow):void {
    const index = this.envManagerSelectedEnvironments.findIndex(selectedEnv => selectedEnv.solName === selectedSolutionRow.data.solName &&
                                                                              selectedEnv.name === selectedSolutionRow.data.name);

    if(selectedSolutionRow.selected && index < 0){
      this.envManagerSelectedEnvironments.push(selectedSolutionRow.data);
    }else if(!selectedSolutionRow.selected && index >= 0){
      this.envManagerSelectedEnvironments.splice(index, 1);
    }
  }

  updateSelectedSolutions(selectedSolutionRow:DataTableRow):void {
    const index = this.solManagerSelectedSolutions.findIndex(selectedSol => selectedSol.name === selectedSolutionRow.data.name);

    if(selectedSolutionRow.selected && index < 0){
      this.solManagerSelectedSolutions.push(selectedSolutionRow.data);
    }else if(!selectedSolutionRow.selected && index >= 0){
      this.solManagerSelectedSolutions.splice(index, 1);
    }
  }

  updateDataCtrlForm(): void {
    if(this.userRoleCtrl.value === UserRole.SUPERUSER.toString() || 
      this.userRoleCtrl.value === UserRole.ADMINSTRATOR.toString()){
      this.dataCtrl.reset({ value: this.userRoleCtrl.value});
    }else if(this.userRoleCtrl.value === UserRole.SOLUTION_MANAGER.toString()){
      this.dataCtrl.reset();
      this.dataCtrl.setValue(this.solManagerSelectedSolutions);
      if(this.solManagerSelectedSolutions.length == 0){
        this.dataCtrl.setErrors({'error':true});
      }
    }else if(this.userRoleCtrl.value === UserRole.ENVIRONMENT_MANAGER.toString()){
      this.dataCtrl.reset();
      this.dataCtrl.setValue(this.envManagerSelectedEnvironments);
      if(this.envManagerSelectedEnvironments.length == 0){
        this.dataCtrl.setErrors({'error':true});
      }
    }

  }

  searchOTDSUsers(query:string): void {
    if(query && query.length > 0){
      this.isSearchingOTDSUser = true;
      this.userService.searchOTDSUsers(query).pipe(
        tap((resp) => {
          this.OTDSUsers = resp.body;
        }),
        finalize(() => {
          this.isSearchingOTDSUser = false;
        })
      ).subscribe();
    }
  }

  selectOTDSUser(otdsUser:OTDSUser): void {
    this.userNameCtrl.setValue(otdsUser.id);
    this.givenNameCtrl.setValue(otdsUser.givenName);
    this.surNameCtrl.setValue(otdsUser.surname);
    this.OTDSUserNameCtrl.setValue('');
    this.OTDSUsers = [];
    this.userNameCtrl.markAsTouched();
  }

  @HostListener("document:click", [])
    clickout() {
        const hostElem = this.eleRef.nativeElement;
        if(hostElem.children[0].children[1]){
          hostElem.children[0].children[1].classList.remove("ot-dropdown--is-active");
        }
        this.OTDSUsers = [];
    }
}
